import type { ThemePreference } from "../preferences/types";
const lightLogo = new URL("../../assets/lyncia.png", import.meta.url).href;
const darkLogo = new URL("./lyncia-dark.png", import.meta.url).href;
export const logoForTheme = (theme: ThemePreference) => theme === "dark" ? darkLogo : lightLogo;
